var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"color":"primary","readonly":"","hide-details":"","label":_vm.label,"input-value":_vm.value},on:{"click":function($event){return _vm.$emit('switchFlag', !_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }